import InfoButton from '../../../components/InfoButton/InfoButton'
import ComingSoon from '../../../components/ComingSoon/ComingSoon'
import '../Section.css'

function BloomBoard() {
  return (
    <div className="dashboard-section">
      <h1>
        Bloom Board
        <InfoButton
          title="Bloom Board"
          content={
            <div>
              <p>
                Manage your floral arrangements and flower preferences. Confirm your floral order, 
                double-check delivery and setup times, and keep all your flower inspiration in one place.
              </p>
              <p>
                <strong>Features:</strong>
              </p>
              <ul>
                <li>Save flower inspiration and arrangements</li>
                <li>Track floral orders and delivery dates</li>
                <li>Organize by location (ceremony, reception, etc.)</li>
                <li>Add color schemes and preferences</li>
                <li>Share with your florist</li>
              </ul>
              <p>
                Flower power — organized and beautiful.
              </p>
            </div>
          }
        />
      </h1>
      <ComingSoon messageIndex={2} />
    </div>
  )
}

export default BloomBoard
